import React, { useEffect, useState } from "react";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Handlebars from "handlebars";
import { useSession } from "../sessionProvider";
import dayjs from 'dayjs';


const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `2px solid rgba(0, 0, 0, 0.03)`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "2px solid rgba(0, 0, 0, 0.03)",
}));

function ItemDetails(props: any) {

    //console.log(props);
    const {ownerId} = useSession();

    interface sections {
        manufacturerInfo: any;
        itemInfo: any;
        manufacturerAccess: any;
    }

    const sections: sections = {
        manufacturerInfo: "Manufacturer Info",
        itemInfo: "Passport Info",
        manufacturerAccess: "Manufacturer Access",
    };

    const itemData = props.itemData;
    const manufacturerData = props.manufacturer;

    const [expanded, setExpanded] = React.useState<string | false>(
        sections.itemInfo
    );
    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    };

    const templates = {
            manufacturerInfo: Handlebars.compile(`
                <div class="product-details" >
                <h2 class="sub-title">OFFICIAL NAME: </h2><p>{{official_name}}</p>
                <h2 class="sub-title">OFFICIAL WEBSITE: </h2><a  href={{official_website}} target="_blank">{{official_website}}</a>
                <h2 class="sub-title">SUMMARY: </h2><p>{{summary}}</p>
                <h2 class="sub-title">LOCATION: </h2><p>{{location_country}}</p>

                {{~#if location_iso}}
                    <h2 class="sub-title">LOCATION ISO: </h2><p>{{location_iso}}</p>
                {{~/if~}}

                {{~#if bussiness_registry_info}}
                    <h2 class="sub-title">BUSINESS REGISTRY INFO: </h2><a  href={{bussiness_registry_info}} target="_blank">{{bussiness_registry_info}}</a>
                {{~/if~}}

                {{~#if eori}}
                    <h2 class="sub-title">EORI: </h2><p>{{eori}}</p>
                {{~/if~}}

                </div>
            `),
            itemInfo: Handlebars.compile(`
                <div class="product-details">
                <h2 class="sub-title">PASSPORT ID: </h2><p>{{pass_id}}</p>
                <h2 class="sub-title">TIMESTAMP: </h2><p>{{timestamp}}</p>
                <h2 class="sub-title">BATCH NUMBER: </h2><p>{{quantity_made}}</p>
                <h2 class="sub-title">PROJECT START DATE: </h2><p>{{project_start_date}}</p>
                </div>
            `),

            manufacturerAccess: Handlebars.compile(`
                <div class="product-details">
                    <h2 class="sub-title">BATCH OF MATERIAL: </h2><p>{{batch_of_material}}</p>
                    <h2 class="sub-title">ACTUAL PRODUCTION PRICE: </h2><p>{{actual_production_price}}</p>
                    <h2 class="sub-title">PLANNED PRODUCTION PRICE: </h2><p>{{planned_production_price}}</p>
                    <h2 class="sub-title">ACTUAL PLANNED DIFF(eur): </h2><p>{{actual_planned_diff_in_eur}}</p>
                    <h2 class="sub-title">ACTUAL PLANNED DIFF(%): </h2><p>{{actual_planned_diff_percentage}}</p>
                </div>
            `),
            
        };

  const templateData = {
        manufacturerInfo: {
            official_name: manufacturerData.name,
            official_website: manufacturerData.website_url,
            summary: manufacturerData.summary,
            location_country: manufacturerData.location,
            location_iso: manufacturerData.location_iso,
            bussiness_registry_info:manufacturerData.business_registry_info,
            eori: manufacturerData.eori,
        },
            itemInfo: {
            pass_id:itemData.id,
            timestamp: ( new Date(itemData.created_at  * 1000)).toString().split(" GMT")[0],
            quantity_made:itemData.batch_number,
            project_start_date: itemData.project_age,
        },
            manufacturerAccess: {
            timestamp: itemData.manufacturer_access.timestamp !== "" ? ( new Date(itemData.manufacturer_access.timestamp  * 1000)).toString().split(" GMT")[0] : "N/A",
            batch_of_material:itemData.manufacturer_access.batch_material !== "" ? itemData.manufacturer_access.batch_material : "N/A",
            actual_production_price: itemData.manufacturer_access.actual_production_price !== "" ? itemData.manufacturer_access.actual_production_price : "N/A",
            planned_production_price: itemData.manufacturer_access.planned_production_price !== "" ? itemData.manufacturer_access.planned_production_price : "N/A",
            actual_planned_diff_in_eur: itemData.manufacturer_access.actual_planned_diff_in_eur !== "" ? itemData.manufacturer_access.actual_planned_diff_in_eur : "N/A",
            actual_planned_diff_percentage: itemData.manufacturer_access.actual_planned_diff_percentage !== "" ? itemData.manufacturer_access.actual_planned_diff_percentage : "N/A",
            //op_difference_from_planned_op: itemData.manufacturer_access.lc_deviation !== "" ? itemData.manufacturer_access.lc_deviation : "N/A",
        },
  };

  return (
    <>
      {Object.entries(sections).map(([section, prettyName]) => {
          if(prettyName === "Manufacturer Access" && ownerId !== itemData.owner_id) {
            return( <span key={prettyName}></ span>)
          }
          
          return (
        <Accordion
          expanded={expanded === section}
          onChange={handleChange(section)}
          key={section}
          sx={{ width: "80%", margin:"auto" }}
          id={section}
        >
          <MuiAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ minHeight: "38px" }}
          >
            <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
              {prettyName}
            </Typography>
          </MuiAccordionSummary>
          <AccordionDetails>
           
            <div
                dangerouslySetInnerHTML={{
                    __html: templates[section as keyof typeof templates](
                    templateData[section as keyof typeof templateData]
                    ),
                }}
            ></div>
            
          </AccordionDetails>
        </Accordion>
      )})}
    </>
  );
}

export default ItemDetails;
